<div
    class="container-fluid well"
    data-test-automation="field-record">
    <h5 [ngClass]="{'required-input': isRequired()}">{{title}}</h5>

    <div class="row">
        <div class="form-group">
            @for (fieldRecord of getModel().fieldRecords; track fieldRecord; let i = $index) {
                <div
                    class="field-record col-xs-4"
                    data-test-automation="field-record-number">
                    <label
                        class="control-label"
                        for="fieldRecord{{i}}"
                        style="display: none"
                        >Field record</label
                    >
                    @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                        <div>
                            <div
                                class="input-group"
                                [ngClass]="{'has-error':
                     (fieldRecord.fieldRecordNumber === 0
                     || fieldRecordInput.errors?.number
                     || isFieldRecordDupicate(getModel().fieldRecords[i]))
                      && (fieldRecordInput.dirty || submitted)
                      || hasMandatoryError(fieldRecordInput)
                      }">
                                <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                                <input
                                    type="number"
                                    class="form-control"
                                    #fieldRecordInput="ngModel"
                                    id="fieldRecord{{i}}"
                                    [name]="'fieldRecord'+i"
                                    min="0"
                                    maxlength="8"
                                    placeholder="Enter Field Record Number"
                                    title="Enter or modify the field record number"
                                    [ngModel]="fieldRecord.fieldRecordNumber"
                                    (input)="onFieldRecordChange($event, i, 8)"
                                    [disabled]="isDisabled()"
                                    [required]="isRequired()"
                                    data-test-automation="field-record-number" />
                                @if (!isDisabled()) {
                                    @if (allowAdditionalFieldBooks()) {
                                        <span class="input-group-addon">
                                            <i
                                                class="nlrp-icon nlrp-icon-add"
                                                tabindex="0"
                                                (click)="addFieldRecord()"
                                                title="Add additional field record number"
                                                data-test-automation="add-field-record-number"></i>
                                        </span>
                                    }
                                    @if (i > 0) {
                                        <span class="input-group-addon">
                                            <i
                                                class="nlrp-icon nlrp-icon-remove"
                                                tabindex="0"
                                                (click)="removeFieldRecord(i)"
                                                title="Delete the field record number"
                                                data-test-automation="remove-field-record-number"></i>
                                        </span>
                                    }
                                }
                            </div>
                            @if (fieldRecordInput.errors?.number && fieldRecordInput.dirty) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>Field record has to be a number.</span>
                                </div>
                            }
                            @if (isFieldRecordDupicate(getModel().fieldRecords[i], i) && fieldRecordInput.dirty) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>This field record has already been entered. A field record may only be entered once.</span>
                                </div>
                            }
                            @if ((fieldRecord.fieldRecordNumber === 0) && fieldRecordInput.dirty) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>Zero is not a valid field record number.</span>
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</div>
<!--<div class="help-block">-->
<!--    <span>Error!</span>-->
<!--    <span>{{groups.planInformation.invalidFieldRecordText}}</span>-->
<!--</div>-->
